import { createSlice } from "@reduxjs/toolkit";


let initialState = {
  fromYear: new Date().getFullYear(),
  toYear: new Date().getFullYear() + 1
};

const yearSlice = createSlice({
  name: "financialYear",
  initialState,
  reducers: {
    SetFromYear: (state, action) => {
      state.fromYear = action.payload;
      state.toYear = action.payload + 1;
    },
  },
});

export const { SetFromYear } = yearSlice.actions;
export default yearSlice.reducer;
